export default {
    title: "Ankieta przesłana",
    header: "@:views.survey.submitted.title",
    message: "Dziękujemy za twoją opinię.",
}